import React from "react";
import { TooltipProvider as TooltipPrimitiveProvider } from "@radix-ui/react-tooltip";
import PropTypes from "prop-types";
TooltipProvider.propTypes = {
    children: PropTypes.node.isRequired
};
export default function TooltipProvider(param) {
    var children = param.children;
    return /*#__PURE__*/ React.createElement(TooltipPrimitiveProvider, {
        skipDelayDuration: 0
    }, children);
}
